import * as React from "react";

export interface ProtectedRouteProps {
  element?: React.JSX.Element;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  return element ? element : null;
};
